import axios from "axios";
import store from '@/store';

export default async function ec91AppRedirectAuth({ next, to }) {
  const org_code = to.params.org_code;

  // 先從 URL 中提取 access_token (格式: query parameter 或 hash fragment)
  let urlAccessToken = to.query.access_token;

  if (!urlAccessToken && to.hash) {
    const hashParams = new URLSearchParams(to.hash.substring(1));
    urlAccessToken = hashParams.get('access_token');
  }

  // 取得目前已保存的 access_token
  const storedAccessToken = store.getters['web/ec-91-auth/accessToken'];
  const isTokenValid = store.getters['web/ec-91-auth/isTokenValid'];

  // 判斷是否需要重新驗證
  let needsReauth = false;

  if (urlAccessToken) {
    // URL 中有 access_token
    if (urlAccessToken !== storedAccessToken) {
      // 新的 access_token 與已保存的不同，需要重新驗證（切換使用者）
      needsReauth = true;
    } else if (!isTokenValid) {
      // access_token 相同但 JWT token 已過期，需要重新驗證
      needsReauth = true;
    } else {
      // access_token 相同且 token 有效，直接通過（但仍需清除 URL 中的 access_token）
    }
  } else {
    // URL 中沒有 access_token，檢查現有 token 是否有效
    if (isTokenValid) {
      return next();
    } else {
      // Token 過期且沒有新的 access_token，清除舊的認證資料
      store.dispatch('web/ec-91-auth/clearAuth');
      return next();
    }
  }

  // 執行驗證或清除 URL
  if (needsReauth && urlAccessToken) {
    try {
      // 呼叫 API 進行驗證
      const response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/${org_code}/web/ec91app/redirect-auth`, {
        access_token: urlAccessToken,
      });
      
      if (response.data.status === 'success') {
        // 將驗證資料存入 Vuex store
        store.dispatch('web/ec-91-auth/setAuthData', {
          accessToken: response.data.data.access_token,
          jwtToken: response.data.data.jwt_token,
          customer: response.data.data.customer,
        });

        // 認證成功後，移除 URL 中的 access_token 參數，避免安全問題
        const cleanQuery = { ...to.query };
        delete cleanQuery.access_token;

        // 移除 hash 中的 access_token
        let cleanHash = to.hash;
        if (to.hash && to.hash.includes('access_token=')) {
          const hashParams = new URLSearchParams(to.hash.substring(1));
          hashParams.delete('access_token');
          cleanHash = hashParams.toString() ? '#' + hashParams.toString() : '';
        }

        // 如果還有其他 query parameters 或 hash，保留它們
        if (Object.keys(cleanQuery).length > 0 || cleanHash) {
          return next({
            path: to.path,
            query: cleanQuery,
            params: to.params,
            hash: cleanHash,
            replace: true
          });
        } else {
          // 如果沒有其他 query parameters 或 hash，直接導向原本的路徑
          return next({
            path: to.path,
            params: to.params,
            replace: true
          });
        }
      } else {
        // 驗證失敗，仍然清除 URL 參數
      }
    } catch (error) {
      // API 呼叫失敗，仍然清除 URL 參數
    }
  } else if (urlAccessToken) {
    // access_token 相同且 token 有效，只需清除 URL 中的 access_token
    const cleanQuery = { ...to.query };
    delete cleanQuery.access_token;

    let cleanHash = to.hash;
    if (to.hash && to.hash.includes('access_token=')) {
      const hashParams = new URLSearchParams(to.hash.substring(1));
      hashParams.delete('access_token');
      cleanHash = hashParams.toString() ? '#' + hashParams.toString() : '';
    }

    if (Object.keys(cleanQuery).length > 0 || cleanHash) {
      return next({
        path: to.path,
        query: cleanQuery,
        params: to.params,
        hash: cleanHash,
        replace: true
      });
    } else {
      return next({
        path: to.path,
        params: to.params,
        replace: true
      });
    }
  }

  return next();
}
